import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';

import {ConfirmationService} from 'primeng/api';

import {EventService} from '../../../../core';
import {TokenService} from '../../../../core/auth';
import {User, UserApiKey} from '../../../../core/models';
import {UserService} from '../../../../core/services';

@Component({
    selector: 'app-user-password-update',
    templateUrl: './user-password-update.component.html'
})
export class UserPasswordUpdateComponent implements OnInit {

    @Input() user: User;

    busy = false;
    displayDialog = false;

    validPassword: boolean;
    newPassword: string;
    confirmPassword: string;

    constructor(
        private router: Router,
        private token: TokenService,
        private confirmationService: ConfirmationService,
        private eventService: EventService,
        private userService: UserService
    ) {
    }

    ngOnInit() {
        this.userService.getApiKey(this.user.id).subscribe(
            (data) => {
                this.busy = false;
            }
        );
    }

    toggleDialog() {
        this.newPassword = null;
        this.confirmPassword = null;
        this.displayDialog = !this.displayDialog;
    }

    cancel() {
        this.displayDialog = false;
    }

    passwordChanged(isOk) {
        this.validPassword = isOk;
    }

    updatePassword() {
        if (this.validPassword) {
            this.busy = true;
            this.user.password = this.confirmPassword;
            this.userService.update(this.user).subscribe(
                (data) => {
                    this.busy = false;
                    this.cancel();
                },
                (error) => {
                    this.busy = false;
                });
        }
    }

}
